import { useEffect } from "react";
import { setPageMeta } from "@/lib/api";
import { Splatter } from "@/components/Splatter";
import { Phone, Mail, Globe, MapPin } from "lucide-react";

export default function Contact() {
  useEffect(() => { setPageMeta("Contact — Tenay Ain-Pression", "Contactez Tenay Ain-Pression : Chris 06 35 30 72 84, Nico 07 81 90 12 48, tenay.ain.pression@gmail.com"); }, []);
  return (
    <div>
      <section className="relative overflow-hidden border-b border-white/10">
        <Splatter />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-14">
          <h1 className="font-heading text-4xl sm:text-5xl font-black">Contact</h1>
          <p className="mt-3 text-gray-400 max-w-2xl">Une question, un projet ? Appelez-nous ou écrivez-nous, on adore les nouveaux défis.</p>
        </div>
      </section>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-12 grid gap-6 sm:grid-cols-2">
        <a href="tel:+33635307284" data-testid="contact-call-chris" className="card-hover rounded-2xl border border-[#222] bg-[#0A0A0A] p-7 flex items-center gap-4">
          <span className="rounded-full btn-primary p-4"><Phone className="w-6 h-6" /></span>
          <div><p className="text-sm text-gray-400">Appeler Chris</p><p className="font-heading font-bold text-xl">06 35 30 72 84</p></div>
        </a>
        <a href="tel:+33781901248" data-testid="contact-call-nico" className="card-hover rounded-2xl border border-[#222] bg-[#0A0A0A] p-7 flex items-center gap-4">
          <span className="rounded-full btn-blue p-4"><Phone className="w-6 h-6" /></span>
          <div><p className="text-sm text-gray-400">Appeler Nico</p><p className="font-heading font-bold text-xl">07 81 90 12 48</p></div>
        </a>
        <a href="mailto:tenay.ain.pression@gmail.com" className="card-hover rounded-2xl border border-[#222] bg-[#0A0A0A] p-7 flex items-center gap-4">
          <span className="rounded-full bg-white/10 p-4"><Mail className="w-6 h-6 text-[#E6007E]" /></span>
          <div><p className="text-sm text-gray-400">E-mail</p><p className="font-heading font-bold text-lg break-all">tenay.ain.pression@gmail.com</p></div>
        </a>
        <div className="rounded-2xl border border-[#222] bg-[#0A0A0A] p-7 flex items-center gap-4">
          <span className="rounded-full bg-white/10 p-4"><Globe className="w-6 h-6 text-[#0055FF]" /></span>
          <div><p className="text-sm text-gray-400">Site & zone</p><p className="font-heading font-bold text-lg">www.tenay-ain-pression.fr</p><p className="text-gray-400 flex items-center gap-1 mt-1"><MapPin className="w-4 h-4" /> Tenay, Ain (01)</p></div>
        </div>
      </div>
      <p className="text-center text-xs text-gray-600 pb-8">SIRET : 50471513700072</p>
    </div>
  );
}
